module.exports = __webpack_public_path__ + "static/media/14-ball.68f60df7.png";